import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import Button from "../base/Button";
import logo from "../../assets/logo.png";

export default function Header() {
	const [isScrolled, setIsScrolled] = useState(false);
	const [menuOpen, setMenuOpen] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setIsScrolled(window.scrollY > 50);
		};
		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	const scrollToSection = (sectionId: string) => {
		const element = document.getElementById(sectionId);
		if (element) {
			element.scrollIntoView({ behavior: "smooth" });
			setMenuOpen(false);
		}
	};

	return (
		<header
			className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
				isScrolled
					? "bg-white/95 backdrop-blur-md shadow-lg"
					: "bg-white/90"
			}`}
			style={{ overflowX: "hidden", maxWidth: "100vw" }}
		>
			<div className="max-w-[1280px] mx-auto px-4 py-2 w-full">

				<div className="flex items-center justify-between">
					{/* Logo + nome */}
					<div className="flex items-center space-x-3">
						<img
							src={logo}
							alt="Logo Renzi Rossi"
							className="h-10 sm:h-12 md:h-10 lg:h-14 w-auto object-contain transition-all duration-300"
						/>
						{/* Nome: aparece no desktop grande e no celular, mas some em telas intermediárias */}
<h1 className="text-sm sm:text-lg md:text-2xl font-bold text-gray-800 block md:hidden lg:block leading-tight">
  Contabilidade Renzi Rossi
</h1>


					</div>

					{/* Navegação Desktop */}
					<nav className="hidden md:flex items-center space-x-6 lg:space-x-8">
						{[
							"inicio",
							"servicos",
							"certificado",
							"sobre",
							"contato",
						].map((item, i) => (
							<button
								key={i}
								onClick={() => scrollToSection(item)}
								className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium text-sm md:text-base lg:text-lg"
							>
								{item === "inicio"
									? "Início"
									: item === "servicos"
									? "Serviços"
									: item === "certificado"
									? "Certificado Digital"
									: item === "sobre"
									? "Sobre Nós"
									: "Contato"}
							</button>
						))}
					</nav>

					{/* Botão Desktop */}
					<div className="hidden md:flex items-center space-x-4">
						<Button
							onClick={() => scrollToSection("contato")}
							className="bg-blue-600 hover:bg-blue-700 text-white"
						>
							<i className="ri-calendar-check-line mr-2"></i>
							Agende sua Consulta
						</Button>
					</div>

					{/* Ícone do menu (mobile) */}
					<button
						className="md:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100"
						onClick={() => setMenuOpen(!menuOpen)}
						aria-label="Abrir menu"
					>
						{menuOpen ? <X size={28} /> : <Menu size={28} />}
					</button>
				</div>
			</div>

			{/* Menu Mobile */}
			{menuOpen && (
				<div className="md:hidden bg-white border-t border-gray-200 shadow-md flex flex-col items-center space-y-4 py-4">
					{[
						"inicio",
						"servicos",
						"certificado",
						"sobre",
						"contato",
					].map((item, i) => (
						<button
							key={i}
							onClick={() => scrollToSection(item)}
							className="text-gray-700 hover:text-blue-600 font-medium"
						>
							{item === "inicio"
								? "Início"
								: item === "servicos"
								? "Serviços"
								: item === "certificado"
								? "Certificado Digital"
								: item === "sobre"
								? "Sobre Nós"
								: "Contato"}
						</button>
					))}

					<Button
						onClick={() => scrollToSection("contato")}
						className="bg-blue-600 hover:bg-blue-700 text-white mt-2"
					>
						<i className="ri-calendar-check-line mr-2"></i>
						Agende sua Consulta
					</Button>
				</div>
			)}

			{/* Faixa azul inferior */}
			<div className="h-1 w-full bg-[#006bbb]"></div>
		</header>
	);
}
